/**
 * Named width tokens for modals
 */
export const modalSizes = {
  xs: 'clamp(240px, 20vw, 360px)',     // Extra small for compact dialogs
  small: 'clamp(280px, 30vw, 400px)',
  medium: 'clamp(320px, 40vw, 600px)',
  large: 'clamp(360px, 60vw, 800px)',
  xlarge: 'clamp(400px, 80vw, 1200px)',
  full: '95vw',
  wide: '80%',                          // 80% of content-area width
  briefing: 'clamp(400px, 90vw, 1200px)' // preserve existing briefing size
};

/**
 * Named height tokens for modals
 */
export const modalHeights = {
  short: 'clamp(200px, 30vh, 400px)',   // Compact height for small dialogs
  tall: '95%',                          // 95% of content-area
  dynamic: null                         // fallback for dynamic sizing (90% of remaining space)
}; 